
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 375 791","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"54","cy":"106","r":"127","fill":"url(#paint0_linear)","fill-opacity":".2"}}),_c('circle',{attrs:{"cx":"154","cy":"724","r":"220","fill":"url(#paint1_linear)","fill-opacity":".4"}}),_c('circle',{attrs:{"cx":"280","cy":"204","r":"150","fill":"url(#paint2_linear)","fill-opacity":".4"}}),_c('defs',[_c('linearGradient',{attrs:{"id":"paint0_linear","x1":"-3.5","y1":"173","x2":"235","y2":"21.5","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"offset":".177","stop-color":"#F6F6F6","stop-opacity":"0"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#fff"}})]),_c('linearGradient',{attrs:{"id":"paint1_linear","x1":"485.5","y1":"580.5","x2":"120","y2":"1087.5","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-color":"#F6F6F6","stop-opacity":"0"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#fff"}})]),_c('linearGradient',{attrs:{"id":"paint2_linear","x1":"552","y1":"341.5","x2":"185","y2":"179","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-color":"#fff"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#fff","stop-opacity":"0"}})])])])
          )
        }
      }
    